<template>
  <CRow>
    <CCol md="12">
      <div class="text-justify">Estas a punto de adquirir uno de los productos de la categoria:</div>
      <br />
      <div class="text-center">
        <div class="category-title">{{ categoryLabel }}</div>
      </div>
      <br />
      <div class="text-center">
        <img :src="item.image_filename ? item.image_filename : 'no-image.jpg'" class="award-image" />
      </div>
      <br />
      <div class="text-center award-name">{{ item.name }}</div>
      <br />
      <div class="text-center award-description">{{ item.description }}</div>
      <br />
      <div class="text-center award-line">Precio en Puntos: {{ item.price }}</div>
      <br />
      <div class="text-center award-line">Disponibles: {{ item.stock }}</div>
      <br />
      <div class="text-justify">
        Si deseas continuar con el <b>canje de puntos</b>, se te descontaran
        <span class="font-weight-bold">{{ item.price }} puntos</span> de tu cuenta y en los proximos dias te
        contactaremos para entregarte el premio seleccionado.
      </div>
    </CCol>
  </CRow>
</template>

<script>
export default {
  name: 'AwardBuyModalDefaultContent',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    categoryLabel () {
      if (this.item.type === 'event_points') return 'Eventos y Conciertos'
      if (this.item.type === 'card_points') return 'Certificados Digitales'
      if (this.item.type === 'gift_points') return 'Premios en Especie'
      if (this.item.type === 'wallet_points') return 'Depositos en Monedero'
      return 'Recompensas'
    }
  }
}
</script>

<style scoped>
.category-title {
  font-size: 14px;
  font-weight: bold;
  color: #2288ee;
}

.award-image {
  height: 120px;
}

.award-name {
  font-size: 14px;
  font-weight: bold;
}

.award-description {
  font-size: 12px;
  font-style: italic;
}

.award-line {
  font-size: 14px;
}
</style>
